<template>
  <v-container fluid
  >
    <v-parallax
    :src="require('@/assets/citybridgenight.jpg')"
    height="600">
      <v-container fill-height>
        <v-layout align-center>
          <v-layout row wrap text-xs-center>
            <v-flex xs12>
              <h1 class="display-2 font-weight-thin white--text">Exicon helps companies raise capital.</h1>
              <h2 class="display-5 white--text">So that they can achieve their strategic and financial objectives.</h2>
              <v-btn 
              color="success" 
              class="white--text"
              large
              :to="'/info'">Learn More</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-parallax>
    <v-layout row wrap
    >
      <v-flex xs12>
        <v-layout row wrap 
        text-xs-center
        justify-center            
        class="ma-5">
          <h1 class="display-2 font-weight-thin my-2">Our Services</h1>
          <h1 class="display-5 font-weight-thin my-2">We help companies achieve their  goals by identifying strategic partners or international investors for a total or partial acquisition of company assets.</h1>
          <v-btn
          :to="'/contact'">Contact Us</v-btn>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-img
                    class="white--text"
                    height="200px"
                    :src="require('@/assets/handshakecolor.jpg')"
                  >
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="headline">Mergers and Acquisitions</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <v-card-title>
                    <div>
                      <span><strong>Full or partial acquisitions: </strong> industry consolidation, new market entry &amp; modernizing family business.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                    flat
                    class="success--text"
                    :to="'/services'"
                    >Learn More</v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs12 sm6>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-img
                    class="white--text"
                    height="200px"
                    :src="require('@/assets/singaporecolor.jpg')"
                  >
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="headline">Capital Raising</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <v-card-title>
                    <div>
                      <span><strong>Access Global Financial Markets:</strong> growth investment, cost reduction, &amp; modernizing operations.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                    flat
                    class="success--text"
                    :to="'/services'"
                    >Learn More</v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-footer
      height="auto"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          accent
          pt-2
          text-xs-center
          black--text
          xs12
        >
          <p class="mx-3">Achieve your strategic and financial goals with <strong>Exicon Investment Banking</strong></p>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      clients: [
        {
          name: 'Sonda (Chile)',
          img: 'sonda',
          sector: 'Info-Tech'
        },
        {
          name: 'Terpel (Colombia)',
          img: 'terpel',
          sector: 'Oil & Gas'
        },
        {
          name: 'Falabella (Chile)',
          img: 'falabella',
          sector: 'Retail'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .carousel {
    height: 200px;
    width: 80%;
  }

  .client {
    position: absolute;
    bottom: 10px;
    background-color: rgba(0,0,0,0.5);
    color: white;
    font-size: 1.5em;
    padding: 20px;
  }
</style>






// WEBPACK FOOTER //
// src/components/welcome.vue